<template>
    <div id="app" v-if="!preserve">
        <router-view :key="$route.name" />
        <vue-progress-bar />
    </div>
    <div id="app" v-else>
        <errorPage></errorPage>
    </div>
</template>

<script>
import errorPage from "@/views/error/index.vue"
export default {
    components: {
        errorPage
    },
    data () {
        return {
            url: ""
        };
    },
    mounted(){
        
    },
    methods: {
    },
    computed:{
        preserve(){
            let href = window.location.href;
            return href.indexOf('/preserve')>-1
        }
    },
};
</script>
